import Api from "@/service/api";

// 搜索
export async function search(
  options?: { [key: string]: any },
) {
  return Api.request({
    url: "/search/search-product",
    method: "POST",
    data: {
      ...(options || {}),
    },
  });
}

// 搜索过滤条件
export async function searchFilter(
  options?: { [key: string]: any },
) {
  return Api.request({
    url: "/search/agg-product",
    method: "POST",
    data: {
      ...(options || {}),
    },
  });
}

// 搜索推荐
export async function searchMarkets(options?: { [key: string]: any },) {
  return Api.request({
    url: "/askpaul/markets/search",
    method: "GET",
    params: { ...options }
  });
}

// 搜索推荐标签
export async function searchRecommend(options?: { [key: string]: any },) {
  return Api.request({
    url: "/askpaul/markets/recommend",
    method: "GET",
    params: { ...options }
  });
}